import { useEffect, useState } from "react"

const sections = [
    { id: "description", label: "Thông tin chung" },
    { id: "ingredients", label: "Thành phần" },
    { id: "indication", label: "Chỉ định" },
    { id: "contraindication", label: "Chống chỉ định" },
    { id: "dosage", label: "Liều lượng - cách dùng" },
    { id: "drugInteraction", label: "Tương tác thuốc" },
    { id: "storage", label: "Bảo quản" },
    { id: "drugOverdose", label: "Quá liều" },
]

export default function Dashboard() {

    const [activeSection, setActiveSection] = useState("description")
    const HEADER_OFFSET = 144

    // CLICK
    const handleClick = (id: string) => {
        const el = document.getElementById(id)
        if (!el) return

        setActiveSection(id) // 👉 CLICK là active NGAY

        const y =
            el.getBoundingClientRect().top +
            window.scrollY -
            HEADER_OFFSET

        window.scrollTo({
            top: y,
            behavior: "smooth",
        })
    }

    // SCROLL SPY — chọn section gần top nhất (KO trả về mặc định nữa)
    useEffect(() => {
        const handler = () => {
            const positions = sections.map(s => {
                const el = document.getElementById(s.id)
                if (!el) return { id: s.id, distance: Infinity }

                const top = el.getBoundingClientRect().top - HEADER_OFFSET
                return { id: s.id, distance: Math.abs(top) }
            })

            // chọn section có distance nhỏ nhất
            positions.sort((a, b) => a.distance - b.distance)

            setActiveSection(positions[0].id)
        }

        window.addEventListener("scroll", handler)
        return () => window.removeEventListener("scroll", handler)
    }, [])

    return (
        <div>
            <section id="product-information" className="grid grid-cols-3 gap-5 p-5 rounded-[20px] bg-white mb-5">
                <div className="col-span-1 relative hidden-1199">
                    {/* LEFT MENU */}
                    <ul className="flex flex-col gap-3 list-none pl-0 sticky top-[144px]">
                        {sections.map(item => (
                            <li
                                key={item.id}
                                onClick={() => handleClick(item.id)}
                                className={`w-full rounded-[8px] flex items-center py-5 px-3 font-[ggsm] cursor-pointer
                                        ${activeSection === item.id
                                        ? "bg-[var(--primary-color)] text-white"
                                        : "bg-[#FAFAFA] text-[var(--primary-color)] hover:bg-[#D1E7BF]"
                                    }`}
                            >
                                {item.label}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="col-span-2 relative max-w-full-1199">
                    <div
                        className="flex flex-col gap-2 overflow-hidden transition-all duration-500"
                    >
                        <div id="description" className="flex flex-col gap-2 ">
                            <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">Thông tin chung</h3>
                            <div
                                className="[&amp;_*]:m-[revert] [&amp;_iframe]:!max-w-full [&amp;_ul]:[all:revert] [&amp;_ol]:[all:revert] [&amp;_p]:[all:revert] [overflow-wrap:anywhere] [&amp;_table]:inline-block jodit-wysiwyg"
                            >
                                <p>
                                    CÔNG DỤNG: Làm sạch 99.99% Vi rút và vi khuẩn<br /><br />gây hại trên da tay và bụi bẩn trên
                                    da
                                </p>
                                <p>Giúp khử<br /><br />mùi, giữ ẩm, dưỡng da, giúp da tay mềm mại không bị khô</p>
                                <p>THÀNH PHẦN: Ethanol, Aqua, Glycerin, Natri Lactate, Chất tạo mùi hương&nbsp;</p>
                            </div>
                            <div className="flex gap-2 text-[14px] flex-col">
                                <strong>Hồ sơ sản phẩm</strong>
                                <div className="flex flex-col gap-1">
                                    <a
                                        target="_blank"
                                        className="text-[var(--primary-color)]"
                                        href="https://cdn-gcs.thuocsi.vn/thuocsi-live/attachments/20244441bbde2362adcb2d376bd95f34"
                                    >GIẤY CÔNG BỐ CỒN 90 ĐỘ.pdf</a
                                    >
                                </div>
                            </div>
                            <div className="flex gap-2 text-[14px]">
                                <strong>Danh mục:</strong
                                ><a
                                    target="_blank"
                                    className="text-[var(--primary-color)]"
                                    href="/categories/V%E1%BB%87sinhs%C3%A1tkhu%E1%BA%A9n"
                                >Vệ sinh, sát khuẩn</a
                                >
                            </div>
                            <div className="flex gap-2 text-[14px]">
                                <strong>Nhà sản xuất:</strong
                                ><a
                                    target="_blank"
                                    className="text-[var(--primary-color)]"
                                    href="/manufacturers/cong-ty-tnhh-hang-viet-havico"
                                >Havico</a
                                >
                            </div>
                            <div className="flex gap-2 text-[14px]"><strong>Nước sản xuất:</strong><span>Việt Nam</span></div>
                            <div className="flex gap-2 text-[14px]">
                                <strong>Thương hiệu:</strong
                                ><a target="_blank" className="text-[var(--primary-color)]" href="/products?brand=havico">Havico</a>
                            </div>
                        </div>
                        <div
                            id="ingredients"
                            className=" border-[2px] border-[var(--primary-color)] rounded p-4 flex flex-col gap-2 bg-[#F5F5F5]"
                        >
                            <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">Chi tiết thành phần</h3>
                            <ul className="list-none p-0 pr-4 m-0 overflow-y-auto max-h-[220px] space-y-2 scrollbar-primary">
                                <li className="flex justify-between items-center">
                                    <a href="/ingredients/ethanol"><span className="text-[var(--primary-color)]">Ethanol</span></a
                                    ><span>90%</span>
                                </li>
                            </ul>
                        </div>
                        <div id="indication" className="flex flex-col gap-2 ">
                            <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">Chỉ định</h3>
                            <div
                                className="[&amp;_*]:m-[revert] [&amp;_iframe]:!max-w-full [&amp;_ul]:[all:revert] [&amp;_ol]:[all:revert] [&amp;_p]:[all:revert] [overflow-wrap:anywhere] [&amp;_table]:inline-block jodit-wysiwyg"
                            >
                                <p>Sử dụng ngoài da</p>
                            </div>
                        </div>
                        <div id="contraindication" className="flex flex-col gap-2 ">
                            <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">Chống chỉ định</h3>
                            <div
                                className="[&amp;_*]:m-[revert] [&amp;_iframe]:!max-w-full [&amp;_ul]:[all:revert] [&amp;_ol]:[all:revert] [&amp;_p]:[all:revert] [overflow-wrap:anywhere] [&amp;_table]:inline-block jodit-wysiwyg"
                            >
                                <p>chống chỉ định với những thành phần nào của thuốc</p>
                            </div>
                        </div>
                        <div id="dosage" className="flex flex-col gap-2 ">
                            <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">Liều lượng - cách dùng</h3>
                            <div
                                className="[&amp;_*]:m-[revert] [&amp;_iframe]:!max-w-full [&amp;_ul]:[all:revert] [&amp;_ol]:[all:revert] [&amp;_p]:[all:revert] [overflow-wrap:anywhere] [&amp;_table]:inline-block jodit-wysiwyg"
                            >
                                <p>
                                    Xịt trực tiếp lên da với lượng vừa đủ<br />Lưu ý: Liều dùng trên chỉ mang tính chất tham
                                    khảo. Để có liều dùng phù hợp, bạn cần tham khảo ý kiến bác sĩ hoặc chuyên viên y tế
                                </p>
                                <p>
                                    Xịt trực tiếp lên da với lượng vừa đủ<br />Lưu ý: Liều dùng trên chỉ mang tính chất tham
                                    khảo. Để có liều dùng phù hợp, bạn cần tham khảo ý kiến bác sĩ hoặc chuyên viên y tế
                                </p>
                            </div>
                        </div>
                        <div id="drugInteraction" className="flex flex-col gap-2 ">
                            <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">Tương tác thuốc</h3>
                        </div>
                        <div id="storage" className="flex flex-col gap-2 ">
                            <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">Bảo quản</h3>
                            <div
                                className="[&amp;_*]:m-[revert] [&amp;_iframe]:!max-w-full [&amp;_ul]:[all:revert] [&amp;_ol]:[all:revert] [&amp;_p]:[all:revert] [overflow-wrap:anywhere] [&amp;_table]:inline-block jodit-wysiwyg"
                            >
                                <p>bảo quản nhiệt độ phòng, tránh lửa và ánh nắng trực tiếp</p>
                                <p>bảo quản nhiệt độ phòng, tránh lửa và ánh nắng trực tiếp</p>
                                <p>bảo quản nhiệt độ phòng, tránh lửa và ánh nắng trực tiếp</p>
                            </div>
                        </div>
                        <div id="drugOverdose" className="flex flex-col gap-2">
                            <h3 className="text-[18px] text-[var(--primary-color)] font-[ggsm]">Quá liều</h3>
                            <p>
                                Xịt trực tiếp lên da với lượng vừa đủ<br />Lưu ý: Liều dùng trên chỉ mang tính chất tham
                                khảo. Để có liều dùng phù hợp, bạn cần tham khảo ý kiến bác sĩ hoặc chuyên viên y tế
                            </p>
                        </div>
                    </div>
                    {/* <div
                        className="flex justify-end items-end bg-[linear-gradient(180deg,_rgba(255,255,255,0)_0%,_rgba(255,255,255,0.3660057773109243)_24%,_rgba(255,255,255,1)_100%)] absolute bottom-0 left-0 right-0 h-[60px] cursor-pointer"
                    >
                        <div className="absolute bottom-0 left-0 right-0 h-[60px] flex items-end">
                            <button
                                className="w-full mx-auto mt-2 text-[var(--primary-color)] flex items-center justify-center gap-2 py-1"
                            >

                                <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0.666748 1.5L4.00008 4.83333L7.33341 1.5M0.666748 6.16667L4.00008 9.5L7.33341 6.16667"
                                        stroke="#005C29"
                                        strokeWidth="1.33"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                    </div> */}
                </div>
            </section>
        </div >
    )
}